export default "__VITE_ASSET__B9H5yGrv__"